// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7d7acd65","240":"c54066fc","393":"e4923947","667":"e15b1ff4","734":"2caac652","954":"762b5e79","977":"61e2edf0"}[chunkId] + ".chunk.js";
};